<vdw-crud-overview-data-page class="no-background no-padding" [config]="config" [canShowActions]="false"></vdw-crud-overview-data-page>
